import { useCallback, useMemo } from "react";
import omit from "lodash/omit";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { parse } from "qs";

import { buildQueryPath } from "@/utils/queryPath";

const useQueryParamState = (
  paramName: string,
): [string, (newValue?: string) => void] => {
  const { push } = useRouter();
  const path = usePathname() || "";
  const searchParams = useSearchParams();
  const query = parse(searchParams?.toString() || "");
  const otherParams = useMemo(() => omit(query, paramName), [query, paramName]);

  const value = query[paramName];

  const setValue = useCallback(
    (newValue?: string) => {
      const newPath = buildQueryPath(path, {
        ...otherParams,
        ...(newValue
          ? {
              [`${paramName}`]: encodeURIComponent(newValue),
            }
          : {}),
      });
      push(newPath);
    },
    [otherParams, paramName],
  );

  return [value ? decodeURIComponent(String(value)) : "", setValue];
};

export default useQueryParamState;
